import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PaymentsService } from '../../service/main/payments.service';
import { Statistics } from '../../entity';
import Enums from '../../utils/enums';

@Component({
    selector: 'app-payments-chart',
    templateUrl: './payments-chart.component.html'
})
export class PaymentsChartComponent implements OnInit, OnChanges {
    @Input() statisticsTypeId: number;
    paymentStatistics: Array<Statistics>;

    //#region chart data
    chartData: Array<any>;
    chartLabels: Array<any>;
    //#endregion

    //#region chart options
    lineChartOptions: any = {
        responsive: true,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    };
    lineChartColors: Array<any> = [
        {
            backgroundColor: 'rgba(255, 91, 121, 0.6)', // rosu
            pointBackgroundColor: 'rgb(255, 91, 121)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#ff5b79',
            pointHoverBorderColor: 'rgba(255, 91, 121, 1)'
        },
        {
            backgroundColor: 'rgba(255, 239, 178, 0.6)', // galben
            pointBackgroundColor: 'rgb(255, 239, 178)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];
    lineChartLegend = false;
    lineChartType = 'bar';
    //#endregion

    constructor(
        private paymentsService: PaymentsService
    ) { }

    ngOnInit() {
        this.refresh();
    }

    ngOnChanges() {
        // this.refresh();
    }

    refresh() {
        this.paymentsService.getPaymentStatistics(this.statisticsTypeId).subscribe(data => {
            const paymentStatistics = new Array<Statistics>();
            data.forEach(item => {
                const paymentStatistic = new Statistics();
                paymentStatistic.fromObject(item);

                paymentStatistics.push(paymentStatistic);
            });

            this.generateChart(paymentStatistics);
        });
    }

    generateChart(statistics: Array<Statistics>): void {
        switch (this.statisticsTypeId) {
            case Enums.eStatisticsType.Hourly:
                this.generateHourlyChart(statistics);
                break;
            case Enums.eStatisticsType.Daily:
                this.generateDailyChart(statistics);
                break;
            case Enums.eStatisticsType.Monthly:
                this.generateMonthlyChart(statistics);
                break;
        }
    }

    generateHourlyChart(statistics: Array<Statistics>) {
        const chartLabels = [
            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
            '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
            '21', '22', '23'
        ];
        const totalSMS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const totalCard = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        for (const item of statistics) {
            totalSMS[item.Hour] = totalSMS[item.Hour] + item.TotalSMS;
            totalCard[item.Hour] = totalCard[item.Hour] + item.TotalCard;
        }

        this.chartLabels = chartLabels;
        this.chartData = [
            { data: totalSMS, label: 'SMS' },
            { data: totalCard, label: 'Card' }
        ];

        this.paymentStatistics = statistics;
    }

    generateDailyChart(statistics: Array<Statistics>) {
        const chartLabels = this.getDays();
        const totalSMS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const totalCard = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        for (const item of statistics) {
            const index = chartLabels.findIndex(label => label.split('/')[0] === item.Day.toString());

            totalSMS[index] = totalSMS[index] + item.TotalSMS;
            totalCard[index] = totalCard[index] + item.TotalCard;
        }

        this.chartData = [
            { data: totalSMS, label: 'SMS' },
            { data: totalCard, label: 'Card' }
        ];
        this.chartLabels = chartLabels;
        this.paymentStatistics = statistics;
    }

    generateMonthlyChart(statistics: Array<Statistics>) {
        const chartLabels = this.getMonths();
        const totalSMS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const totalCard = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        for (const item of statistics) {
            const index = chartLabels.findIndex(label => label.split('/')[0] === item.Month.toString());

            totalSMS[index] = totalSMS[index] + item.TotalSMS;
            totalCard[index] = totalCard[index] + item.TotalCard;
        }

        this.chartData = [
            { data: totalSMS, label: 'SMS' },
            { data: totalCard, label: 'Card' }
        ];
        this.chartLabels = chartLabels;
        this.paymentStatistics = statistics;
    }

    getMonths(): Array<string> {
        const months = [];
        const now = new Date();
        const startDate = new Date(now.getFullYear(), now.getMonth() - 12, (now.getDate() - now.getDate() + 1));
        const endDate = new Date(now.getFullYear(), now.getMonth(), (now.getDate() - now.getDate() + 1));

        while (startDate < endDate) {
            const month = `${startDate.getMonth() + 1}/${startDate.getFullYear()}`;
            months.push(month);

            startDate.setMonth(startDate.getMonth() + 1);
        }
        return months;
    }

    getDays(): Array<string> {
        const days = [];
        const endDate = new Date();
        const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), (endDate.getDate() - 15));

        while (startDate <= endDate) {
            const day = `${startDate.getDate()}/${startDate.getMonth() + 1}`;
            days.push(day);

            startDate.setDate(startDate.getDate() + 1);
        }

        return days;
    }

    get titleByType(): string {
        switch (this.statisticsTypeId) {
            case Enums.eStatisticsType.Hourly:
                return 'Ziua curenta';
            case Enums.eStatisticsType.Daily:
                return 'Ultimele 16 zile';
            case Enums.eStatisticsType.Monthly:
                return 'Ultimul an';
        }
    }
}
